import { propertyType } from "@agentcall/core/type"
import { Select } from "@/components/ui/select"

const typeOptions = propertyType.PROPERTY_TYPES.map((item) => ({
  value: item.key,
  label: item.value,
}))

interface PropertyTypeSelectorProps {
  value: string
  onChange: (value: string) => void
  error?: string
  placeholder?: string
  disabled?: boolean
  className?: string
}

export function PropertyTypeSelector({
  value,
  onChange,
  error,
  placeholder = "選択してください",
  disabled = false,
  className,
}: PropertyTypeSelectorProps) {
  return (
    <div className={className}>
      <Select
        value={value}
        onChange={onChange}
        options={typeOptions}
        placeholder={placeholder}
        disabled={disabled}
        className="w-full"
      />
      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
    </div>
  )
}
